import React , {useEffect} from 'react';
import { Navigate, useLocation } from "react-router";
import allActions from '../actions/index';
import { useSelector, useDispatch } from 'react-redux';


const RequireAuth = ({ children }) => {
  let location = useLocation();

  /******get data from redux state*******/
  const LoginLogout = useSelector(state => state.LoginLogout);

  /******get data from localstorage*******/
  let authlogin = localStorage.getItem('authlogin');
  let storageData = authlogin ? JSON.parse(authlogin) : "";

  /******initially set loggedin false******/
  var loginFlag = false
  //LoginLogout.user.login==true || 
  if(storageData.login==true){
    var loginFlag = true
  }

  let auth = loginFlag;

  if (auth==false) {
   return <Navigate to="/login" state={{ from: location }} />;
  }
  return children;
};

export default RequireAuth;